(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('action-rms-refresh-list-filter-status', actionFunc);

    function actionFunc($q, rmsListFilterStatusSelectionFactory) {
        return function() {
            $q.when(run());
            function run() {
                const vm = rmsListFilterStatusSelectionFactory.get();
                if (!vm) return false;
                return vm.refreshData();
            }
        };
    }
})();
